module.exports = __webpack_public_path__ + "static/media/CDC-EN-notices-P2.e1f08e19.jpg";